var IBAN = require("iban");

export default {
    data () {
        return{
            rules: {
                requiredRule: [v => !!v || "This field is required"],
                requiredRule50: [
                  v => !!v || "This field is required",
                  v => v.length <= 50 || "Invalid input length"
                ],
                requiredRule128: [
                  v => !!v || "This field is required",
                  v => v.length <= 128 || "Invalid input length"
                ],
                firstNameRules: [
                  v => !!v || "First name is required",
                  v => v.length <= 128 || "Invalid input length"
                ],
                lastNameRules: [
                  v => !!v || "Last name is required",
                  v => v.length <= 128 || "Invalid input length"
                ],
                emailRules: [
                  v => !!v || "E-mail is required",
                  v => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || "E-mail must be valid",
                  v => v.length <= 50 || "Invalid input length"
                ],
                phoneRules: [
                  v => !!v || "Phone number is required",
                  v =>
                    /^[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(
                      v
                    ) || "Phone number must be valid (e.g 37123456789)"
                ],
                countryRules: [
                  v => !!v || "Country is required",
                  v => v.length <= 100 || "Invalid input length"
                ],
                ibanRules: [v => IBAN.isValid(v) || v.length == 0 || "Invalid IBAN"],
                vatNumberRules: [
                  v => !!v || "Valid VAT number is required",
                  v => v.length <= 32 || "Invalid VAT number"
                ],
                bankRules: [v => (v.length >= 3 && v.length <= 64) || "Invalid Bank"],
                bicRules: [
                  v => (v.length >= 8 && v.length <= 11) || "Invalid SWIFT/BIC"
                ]
            },        
        }
    }
}